import { Component, createRef } from 'react'
import { API, Auth } from 'aws-amplify'
import moment from 'moment'
import QRCode from 'qrcode.react'
import withRouter from '../components/withRouter'
import Carousel from 'react-bootstrap/Carousel'
import SmallCard from '../components/smallCard'
import Logo from '../images/GigLoca_Logo_Light.png'
import AppStore from '../images/appstore.svg'
import PlayStore from '../images/playstore.png'
import { FaArrowCircleLeft, FaArrowCircleRight, FaRegWindowClose } from 'react-icons/fa'
import { MdOutlineVerified } from 'react-icons/md'
import { GoUnverified } from 'react-icons/go'
import './node.css'

const timeout = 90000

class Calendars extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: null,
            ntype: 'venue',
            start: moment().date(1).format('YYYY-MM-DD'),
            stop: moment().date(1).add(1, 'month').format('YYYY-MM-DD'),
            selDay: null,
            displayMsg: false,
            msg: '',
            days: [],
            data: null,
            month: moment().date(1),
            css: null,
            src: null,
            title: null,
            displayLink: false,
            tid: null,
            view: 'show',
            images: null,
            qrType: null,
            qrID: null
        }

        this.handleEventSelect = this.handleEventSelect.bind(this)
    }

    CalTop = createRef()

    componentDidMount() {
        const { path, search } = this.props
        const id = path.id || null
        if (id) {
            const queryParams = new URLSearchParams(search.search)
            const css = queryParams.get('color') || null
            let month = this.state.month
            let start = moment(month).subtract(month.day(), 'days').format('YYYY-MM-DD')
            let stop = moment(month).date(44 - (month.day() + moment(month).add(1, 'month').date()), 'days').format('YYYY-MM-DD')
            this.setState({ id, start, stop, css })
            this.getData(id, start, stop, false, true)
        }
    }

    async handleRefresh(clicked) {
        if (this.props.isAuthenticated) {
            try {
                this.props.setUser(null)
                this.props.userHasAuthenticated(false)
                await Auth.signOut({ global: true })
            } catch (e) {
                console.log(e.message)
            }
        }
        if (clicked) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleRefresh(), timeout)
            this.setState({ tid, qrID: null, qrType: null })
            this.scrollToRef(this.CalTop)
        } else {
            let cal = false
            if (this.state.tid) {
                clearTimeout(this.state.tid)
                cal = true
            }
            let month = moment().date(1)
            let start = moment(month).subtract(month.day(), 'days').format('YYYY-MM-DD')
            let stop = moment(month).date(44 - (month.day() + moment(month).add(1, 'month').date()), 'days').format('YYYY-MM-DD')
            this.setState({ month, start, stop, selDay: null, displayLink: false, src: null, title: null, tid: null, view: 'show', qrID: null, qrType: null })
            this.getData(this.state.id, start, stop, cal)
        }
    }

    handleMonthChanged(dir) {
        let month = moment(this.state.month)
        if (dir === 'back') {
            month.subtract(1, 'month')
        } else if (dir === 'next') {
            month.add(1, 'month')
        }
        let start = moment(month).subtract(month.day(), 'days').format('YYYY-MM-DD')
        let stop = moment(month).date(44 - (month.day() + moment(month).add(1, 'month').date()), 'days').format('YYYY-MM-DD')
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ month, start, stop, selDay: null, tid, qrID: null, qrType: null })
        this.getData(this.state.id, start, stop)
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleEventSelect(eid) {
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ displayLink: true, src: `https://gigloca.com/event/${eid}`, title: this.state.data.events[this.state.data.events.findIndex(e => eid === e.id)].title, tid, qrType: 'event', qrID: eid })
    }

    handleCellSelect(selDay) {
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ selDay, tid, qrID: null, qrType: null })
    }

    handleQRClick() {
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ displayLink: true, src: `https://gigloca.com/${this.state.qrType || this.state.ntype}/${this.state.qrID || this.state.id}`, title: '', tid })
    }

    handleIframeClick() {
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ displayLink: false, src: null, title: null, tid, qrID: null, qrType: null })
    }

    handleCalView() {
        let tid = setTimeout(() => this.handleRefresh(), timeout)
        this.setState({ view: 'cal', tid, qrID: null, qrType: null })
    }

    getData(id, start, stop, cal, first) {
        const headers = { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` }
        API.get('lt', `userstuff?nid=${id}&start=${start}&end=${first ? moment(stop).add(1, 'month').format('YYYY-MM-DD') : stop}${cal ? `&cal=true` : ''}`, { headers })
            .then(resp => {
                if (resp.data[0]) {
                    if (resp.data.length > 1 || resp.data[0].nodetype !== 'Venue') {
                        this.setState({ ntype: 'contributor' })
                    }
                    let days = []
                    const events = resp.data[0].events ? (first ? resp.data[0].events.filter(e => moment(e.startTime).isSameOrBefore(moment(stop))) : resp.data[0].events) : []
                    events.sort((a, b) => {
                        if (a.startTime && b.startTime) {
                            if (moment(a.startTime).isBefore(moment(b.startTime))) return -1
                            if (moment(a.startTime).isAfter(moment(b.startTime))) return 1
                            return 0
                        } else return -1
                    }).forEach(e => {
                        if (e.startTime && e.stopTime) {
                            for (let x = moment(e.startTime).date(); x <= moment(e.stopTime).date(); x++) {
                                days.push(x)
                            }
                        }
                    })
                    let images = []
                    if (first) {
                        images = resp.data[0].showArray || []
                        events.forEach(e => {
                            if (e.imageArray) e.imageArray.forEach(i => {
                                if (images.indexOf(i) === -1) images.push(i)
                            })
                        })
                    }
                    this.setState({ data: { ...resp.data[0] }, id, days, images: first ? images : this.state.images, qrID: null, qrType: null })
                }
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
            })
    }

    getMessage() {
        return <div className='Node-Confirm'>
            <div className='Node-Row Confirm-Text'>{this.state.msg}</div>
            <div className="Node-Row Node-Flex-Wrap">
                <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getCal() {
        let month = this.state.month
        let one = month.day()
        let dates = []
        let days = []
        for (let i = 0; i < one; i++) {
            let tmp = moment(month)
            tmp.subtract(one - i, 'days')
            days.push(tmp.date())
            dates.push(tmp.format('YYYY-MM-DD'))
        }
        let last = days.length
        let tmp = moment(month).add(1, 'month').subtract(1, 'day').date()
        for (let i = 1; i <= tmp; i++) {
            days.push(i)
            dates.push(moment(month).date(i).format('YYYY-MM-DD'))
        }
        let next = days.length
        let rem = 42 - days.length
        for (let i = 1; i <= rem; i++) {
            days.push(i)
            dates.push(moment(month).add(1, 'month').date(i).format('YYYY-MM-DD'))
        }
        return <div className='Calendar-Frame'>
            <div className='Calendar-Weekday-Header Node-Flex'>
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d, didx) => {
                    return <div key={`wd-${didx}`} className={`Calendar-Cell Calendar-Cell-Top-Wall${didx === 0 ? ' Calendar-Cell-Left-Wall Calendar-Cell-Top-Left' : ''}${didx === 6 ? ' Calendar-Cell-Right-Wall Calendar-Cell-Top-Right' : ''}`} onClick={() => this.handleCellSelect(null)}>{d}</div>
                })}
            </div>
            <div className='Node-Flex-Wrap'>
                {
                    days.map((day, didx) => {
                        return <div key={`day-${didx}`} style={{ color: `${this.state.css && (this.state.css.toLowerCase() === 'black' || this.state.css.toLowerCase() === 'green') ? '#fff' : '#000'}` }} className={`Calendar-Cell${didx % 7 === 0 ? ' Calendar-Cell-Left-Wall' : ''}${didx % 7 === 6 ? ' Calendar-Cell-Right-Wall' : ''}${didx > 34 ? ' Calendar-Cell-Bottom-Wall' : ''}${didx === 35 ? ' Calendar-Cell-Bottom-Left' : ''}${didx === 41 ? ' Calendar-Cell-Bottom-Right' : ''}${this.state.selDay && moment(this.state.selDay).isSame(moment(dates[didx])) ? ' Calendar-Cell-On' : ''}`} onClick={() => this.handleCellSelect(dates[didx])}>
                            <div style={{ fontWeight: 'bold' }} className={`Calendar-xRow Node-Flex-Right${didx >= next ? ' Calendar-Cell-Off' : ''}${didx < last ? ' Calendar-Cell-Off' : ''}`}>{day}</div>
                            {
                                this.state.data.events ? this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(dates[didx]), moment(dates[didx]).add(1, 'day'))).map((e, eidx) => {
                                    return <div key={`e-${eidx}`} className='Calendar-xRow'>
                                        <div className='Calendar-xRow-Text-Big'><span className={`Calendar-Verified`}>{e.active ? <MdOutlineVerified /> : <GoUnverified />}</span>{e.title}</div>
                                    </div>
                                }) : null
                            }

                        </div>
                    })
                }
            </div>
        </div>
    }

    getEvent() {
        return <div className='Node-Iframe'>
            <div className='Node-Close-Outer'>
                <div className='Node-Close' onClick={() => this.handleIframeClick()}><FaRegWindowClose /></div>
            </div>
            <iframe src={this.state.src} title={this.state.title} width='100%' height='100%'></iframe>
        </div>
    }

    scrollToRef = ref => {
        ref.current.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }

    getHeader() {
        <div className='Node-Flex-Spread' style={{ backgroundColor: '#000', paddingRight: '10px', cursor: 'pointer' }} onClick={() => this.handleRefresh(true)}>
            <div className='Calendar-Title'>{`Calendar for ${this.state.data.name}`}</div>
            <div className='Calendar-Logo'><img src={Logo} style={{ height: '80px' }} alt='Gigloca' /></div>
        </div>
    }

    getCalView() {
        return <div>
            <div className='Node-Row'>
                <div>
                    <div className='Node-Row Node-Flex-Wrap Calendar-xHeader'>
                        <div className='Calendar-xButton' onClick={() => this.handleMonthChanged('back')}><FaArrowCircleLeft /></div>
                        <div>{this.state.month.format('MMMM YYYY')}</div>
                        <div className='Calendar-xButton' onClick={() => this.handleMonthChanged('next')}><FaArrowCircleRight /></div>
                    </div>
                    {this.getCal()}
                </div>
            </div>
            <div className='Node-Row'>
                {this.state.selDay ? this.state.data.events && this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).length > 0 && <div className='Node-Row Node-Flex-Left'>
                    <div style={{ color: '#fff' }} className='Node-Divider-Text'>{moment(this.state.selDay).format('ll')}</div>
                    <div className='Node-Divider'></div>
                </div> : null}
                {this.state.selDay && this.state.data.events && this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).map((event, eidx) => {
                    return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                })}</div>}
                {this.state.data.events ? this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).length > 0 && <div className='Node-Row Node-Flex-Left'>
                    <div style={{ color: '#fff' }} className='Node-Divider-Text'>Upcoming & Current Events</div>
                    <div className='Node-Divider'></div>
                </div> : null}
                {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).map((event, eidx) => {
                    return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                })}</div>}
                {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).length > 0 && <div className='Node-Row Node-Flex-Left'>
                    <div style={{ color: '#fff' }} className='Node-Divider-Text'>Past Events</div>
                    <div className='Node-Divider'></div>
                </div>}
                {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).map((event, eidx) => {
                    return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                })}</div>}
                {this.state.id && <div className='Node-Row Node-Flex-Wrap'><div style={{ cursor: 'pointer' }} onClick={() => { this.handleQRClick() }}><QRCode value={`https://gigloca.com/${this.state.ntype}/${this.state.id}`} /></div></div>}
                <div style={{ color: `${this.state.css && (this.state.css.toLowerCase() === 'black' || this.state.css.toLowerCase() === 'green') ? '#fff' : '#000'}` }} className='Node-Row Cal-Msg'>Stay In the Know by downloading the App or visit gigloca.com!</div>
                <div className='Node-Row Node-Flex-Spread'>
                    <div>
                        <div style={{ width: '150px', textAlign: 'center' }}><QRCode value={`https://apps.apple.com/us/app/gigloca/id6504925922`} /></div>
                        <img className="Download-Button" src={AppStore} alt='Download on the App Store' />
                    </div>
                    <div>
                        <div style={{ width: '169px', textAlign: 'center' }}><QRCode value={`https://play.google.com/store/apps/details?id=com.gigloca&hl=en`} /></div>
                        <img className="Download-Button" src={PlayStore} alt='Download on the App Store' />
                    </div>
                </div>
            </div>
        </div>

    }

    getShowView() {
        return <div>
            {
                this.state.images && <Carousel controls={false} touch={true} indicators={false} interval={10000}>
                    {
                        this.state.images.map((img, imgidx) => {
                            return <Carousel.Item key={`ci-${imgidx}`} style={{ width: '100%', height: 'calc(100vh - 166px)' }}>
                                <div style={{width: '100%', textAlign: 'center'}}><img style={{height: 'calc(100vh - 166px)', objectFit: 'contain' }} src={`https://localtalent-upload.s3.amazonaws.com/public/${img}`} alt={this.state.data.name} /></div>
                            </Carousel.Item>
                        })
                    }
                </Carousel>
            }
        </div>
    }

    render() {
        //console.log(this.state)
        return this.state.data ? <div className={`Calendars-Container`}>
            {this.state.displayLink && this.getEvent()}
            <div className='Node-Flex-Spread' style={{ backgroundColor: '#000', paddingRight: '10px', cursor: 'pointer' }} onClick={() => this.handleRefresh(true)}>
                <div className='Calendar-Title'>{`Calendar for ${this.state.data.name}`}</div>
                {this.state.view === 'show' && <div style={{ margin: '5px' }}><div className='Cal-Button' onClick={() => this.handleCalView()}>Touch for Calendar</div></div>}
                <div className='Calendar-Logo'><img src={Logo} style={{ height: '80px' }} alt='Gigloca' /></div>
            </div>
            <div>
                {this.state.view === 'cal' ? <div ref={this.CalTop} className={`Calendar-xContainer${this.state.css ? ` Calendar-${this.state.css.toLowerCase()}` : ''}`}>{this.getCalView()}</div> : <div ref={this.CalTop} className={`Calendar-xContainerx${this.state.css ? ` Calendar-${this.state.css.toLowerCase()}` : ''}`}>{this.getShowView()}</div>}
            </div>
            <div className='Calendar-Logo Node-Flex-Wrap' onClick={() => this.handleRefresh(true)}><img src={Logo} style={{ height: '80px' }} alt='Gigloca' /></div>
        </div> : <div style={{ padding: '10%' }} className='Empty-Container Node-Black'><img className='Node-Logo' src={Logo} alt="GigLoca" /></div>
        //this.state.data ? (this.state.view === 'cal' ? this.getCalView() : this.getShowView()) : <div style={{ padding: '10%' }} className='Empty-Container Node-Black'><img className='Node-Logo' src={Logo} alt="GigLoca" /></div>
    }
}

export default withRouter(Calendars)